import Vue from "vue";

Vue.filter("date", value => {
  if (value === null) return "";
  const date = value instanceof Date ? value : new Date(Date.parse(value));
  if (!date || isNaN(date.getTime())) return null;

  let day = date.getDate();
  let month = date.getMonth();
  let year = date.getFullYear();

  return (
    day.toString().padStart(2, "0") +
    "-" +
    (month + 1).toString().padStart(2, "0") +
    "-" +
    year.toString()
  );
});

Vue.filter("date_picker_string", value => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(Date.parse(value));
  if (!date || isNaN(date.getTime())) return null;

  const day = date
    .getDate()
    .toString()
    .padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();

  return `${year}-${month}-${day}`;
});

Vue.filter("parse_date", value => {
  if (value === null) return null;
  const day = value.slice(0, 2);
  const month = value.slice(3, 5);
  const year = value.slice(6);

  return new Date(year, month - 1, day);
});
